export const TableHeader = (t) => [
  {
    title: t("labels.country.riskRangeData.table.headers.section"),
    field: "section",
    editable: "never",
    align: "center",
  },
  {
    title: t("labels.country.riskRangeData.table.headers.lowFrom"),
    field: "low_from",
    type: "numeric",
  },
  {
    title: t("labels.country.riskRangeData.table.headers.lowTo"),
    field: "low_to",
    type: "numeric",
  },
  {
    title: t("labels.country.riskRangeData.table.headers.mediumFrom"),
    field: "medium_from",
    type: "numeric",
  },
  {
    title: t("labels.country.riskRangeData.table.headers.mediumTo"),
    field: "medium_to",
    type: "numeric",
  },
  {
    title: t("labels.country.riskRangeData.table.headers.highFrom"),
    field: "low_from",
    type: "numeric",
  },
  {
    title: t("labels.country.riskRangeData.table.headers.highTo"),
    field: "high_to",
    type: "numeric",
  },
];
